import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { AuthHeaders } from '../../../models/auth-headers';
import { selectData } from '../../../utils/select-data';
import { copilotRequestActionSchema } from '../schemas/copilot-fleet-action.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Loads CoPilot Support Fleet Actions
 * @returns An array of the Support Fleet Actions
 */
export function getSupportCopilotFleetActions(this: unknown) {
  return fromFetch(
    new Request(
      accountsEnvironment.resolve(this).supportCopilotFleetActionsUrl,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(), // Doesn't work with JWT for some reason
        },
      }
    )
  ).pipe(selectData(z.array(copilotRequestActionSchema)));
}
